module.exports = __webpack_public_path__ + "static/img/assembly.5993e7e4.svg";